<template>
  <b-modal :id="`modal-${id}`" size="xl">
    <div slot="modal-title">
      <div class="header-div">
        <img src="../../../assets/logoIndecx.png" alt="" />
        <p class="header-font">
          {{ $t('treatments.responseInformation') }}
          {{ returnClient(customer.anonymousResponse, customer.name) }}
          <!-- {{ !customer.anonymousResponse ? customer.name : '***************' }} -->
        </p>
      </div>
    </div>
    <template slot="modal-footer">
      <button
        @click="$bvModal.hide(`modal-${id}`)"
        class="btn btn-outline-primary"
      >
        {{ $t('treatments.close') }}
      </button>
    </template>
    <div class="row mt-4">
      <div class="col-lg-2 text-center">
        <template v-if="customer.metric === 'like-dislike'">
          <h4>Avaliação</h4>
          <span v-if="customer.review === 1">
            <img
              alt="Like"
              width="60"
              height="60"
              src="../../../assets/Like.svg"
            />
          </span>
          <span v-if="customer.review === 0">
            <img
              alt="Deslike"
              width="60"
              height="60"
              src="../../../assets/Deslike.svg"
            />
          </span>
        </template>
        <template v-else>
          <h4>{{ $t('treatments.note') }}</h4>
          <div
            :class="`mt-3 flag-grade flag-grade-${gradeFormat(
              customer.review,
            )}`"
          >
            {{ customer.review === 99 ? '-' : customer.review }}
          </div>
        </template>
      </div>
      <div class="col-lg-10 align-self-end">
        <span class="user-info">
          {{ checkName(customer.anonymousResponse, customer.name) }} </span
        ><br />
        <span class="user-info"
          >{{ $t('treatments.channel') }}: {{ customer.channel }}</span
        ><br />
        <span class="user-info">
          {{ $t('treatments.email') }}:
          {{
            checkUserData(
              customer.anonymousResponse,
              userProfile.permissions.answers.anonymous_profile,
              userProfile.permissions.trash.anonymous_profile,
              customer.email,
            )
          }}</span
        ><br />
        <span class="user-info">
          {{ $t('treatments.phone') }}:
          {{
            checkUserData(
              customer.anonymousResponse,
              userProfile.permissions.answers.anonymous_profile,
              userProfile.permissions.trash.anonymous_profile,
              customer.phone,
            )
          }}</span
        ><br />
        <span class="user-info"
          >{{ $t('treatments.date') }}: {{ dateFormat(customer.date) }}</span
        ><br />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <h4>{{ $t('treatments.comment') }}</h4>
        <hr />
        <p>
          {{
            customer.feedbackEdited.edition
              ? customer.feedbackEdited.edition
              : customer.feedback
          }}
        </p>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <h4>{{ $t('treatments.indicators') }}</h4>
        <hr />
        <div class="indicators">
          <div v-if="customer.indicators.length === 0">
            <span style="font-style: italic;">{{ $t('treatments.none') }}</span>
          </div>
          <div v-for="(indicator, i) in customer.indicators" :key="i">
            <div ref="chip" class="chip">
              {{
                indicatorAnonymous(
                  customer.anonymousResponse,
                  indicator.column,
                  indicator.value,
                  indicator.indicatorId,
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <h4>{{ $t('treatments.additionalQuestions') }}</h4>
        <hr />
      </div>
    </div>
    <div class="row">
      <div
        class="col-12"
        v-for="(item, i) in customer.additionalQuestions"
        :key="i"
      >
        <template
          v-if="
            indicatorValuedQuestion(item) &&
            (!item.conditionalQuestion || !item.conditionalQuestion.length ||
              item.conditionalQuestion.includes(conditionalQuestion()))
          "
        >
          <like-dislike
            v-if="item.type === 'LIKE/DISLIKE'"
            :questionText="item.text"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <emotion
            v-if="item.type === 'EMOTION'"
            :questionText="item.text"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <likert
            v-if="item.type === 'LIKERT'"
            :text="item.text"
            :itemId="i.toString()"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
            :template="item.template"
          />
          <reviews
            v-if="item.type === 'REVIEWS'"
            :text="item.text"
            :item-id="i.toString()"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <csat
            v-if="item.type === 'CSAT'"
            :text="item.text"
            :item-id="i.toString()"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :colorTemplate="
              customer.actionId ? customer.actionId.email.template.scale : ''
            "
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <multiple-choices
            v-if="item.type === 'MULTIPLE'"
            :type="item.multipleType"
            :questionText="item.text"
            :choices="item.multipleValues"
            :justView="true"
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <ces
            v-if="item.type === 'CES'"
            :text="item.text"
            :item-id="i.toString()"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :colorTemplate="
              customer.actionId ? customer.actionId.email.template.scale : ''
            "
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <input-type
            v-if="item.type === 'INPUT'"
            :text="item.text"
            :answerText="item.answerText"
            :index="i"
            :justView="true"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <label-question
            v-if="item.type === 'LABEL'"
            :text="item.text"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <nps
            v-if="item.type === 'NPS'"
            :text="item.text"
            :item-id="i.toString()"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :colorTemplate="
              customer.actionId ? customer.actionId.email.template.scale : ''
            "
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
          <likertEmotion
            v-if="item.type === 'LIKERT/EMOTION'"
            :text="item.text"
            :item-id="i.toString()"
            :index="i"
            :justView="true"
            :selected="parseInt(item.review)"
            :colorTemplate="
              customer.actionId ? customer.actionId.email.template.scale : ''
            "
            :hasComment="item.comment"
            :reviewAnswer="item.review ? item.review : -99"
          />
        </template>
      </div>
    </div>
  </b-modal>
</template>

<script>
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import likert from '@/components/molecules/metrics/likert';
import csat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import reviews from '@/components/molecules/metrics/reviews';
import { mapState } from 'vuex';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import inputType from '@/components/molecules/metrics/input-type';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import labelQuestion from '@/components/molecules/metrics/label-question';
import { lightFormat } from 'date-fns';
// import imgPath from '../../../assets/logoIndecx.png';
import api from '../../../services/api';

export default {
  props: {
    id: { type: Number, required: true },
    customer: { type: Object, required: true },
  },

  data: () => ({
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    ih1Value: null,
    branches: [],
    indicatorsAction: [],
  }),

  components: {
    likeDislike,
    emotion,
    likert,
    csat,
    nps,
    reviews,
    multipleChoices,
    inputType,
    labelQuestion,
    ces,
    likertEmotion,
  },

  async created() {
    await this.getAllBranches();
    await this.getIndicators();

    if (this.customer.metric.includes('0-10')) {
      this.promotersGrades = [10, 9];
      this.passivesGrades = [8, 7];
      this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
    }

    if (this.customer.metric === 'like-dislike') {
      this.promotersGrades = [1];
      this.detractorsGrades = [0];
    }
  },

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('branches', ['myIh1', 'myIh2']),
  },

  methods: {
    returnClient(isAnonymous, client) {
      if (this.userProfile.permissions.answers.menu) {
        if (
          isAnonymous &&
          !this.userProfile.permissions.answers.anonymous_profile
        ) {
          return 'Anônimo';
        } else if (this.userProfile.permissions.answers.anonymous_profile) {
          return '**************';
        } else if (client) {
          return client;
        }
      }

      if (this.userProfile.permissions.answers.anonymous_profile) {
        return '**************';
      }

      return '**************';
    },

    async getIndicators() {
      const indicators = await api.get(
        `/indicator/${this.customer.actionId._id}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            answerForm: true,
          },
        },
      );

      this.indicatorsAction = indicators.data;
    },

    indicatorAnonymous(anonymous, column, indicator, indicatorId) {
      let anonymousIndicator = false;
      this.indicatorsAction.forEach((el) => {
        if (el._id === indicatorId) {
          if (el.anonymous) {
            anonymousIndicator = true;
          } else {
            anonymousIndicator = false;
          }
          for (let idx = 0; idx < el.types.length; idx += 1) {
            if (el.types[idx] === 'anonymous' || el.types[idx] === 'clientId') {
              anonymousIndicator = true;
              break;
            }
          }
        }
        // return `${column}: ${indicator}`;
      });
      if (
        anonymous ||
        this.userProfile.permissions.answers.anonymous_profile ||
        anonymousIndicator
      ) {
        if (this.customer.ih1) {
          this.branches.branches.forEach((el) => {
            if (el._id === this.customer.ih1) {
              this.ih1Value = el.corporate_name;
            }
          });

          // in anonymous case it returns only the value of ih1
          if (indicator === this.ih1Value) {
            return `${column}: ${this.ih1Value}`;
          }
        }
        if (anonymous && anonymousIndicator) {
          return `${column}: **`;
        }

        if (anonymousIndicator && this.userProfile.permissions.answers.anonymous_profile) {
          return `${column}: **`;
        }

        return `${column}: ${indicator}`;
      } else if (indicator) {
        return `${column}: ${indicator}`;
      }
      return `${column}: ${indicator}`;
    },

    async getAllBranches() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

      const response = await api.get(
        `treatments/branches/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      this.branches = response.data;
    },

    conditionalQuestion() {
      if (this.promotersGrades.includes(this.customer.review)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.customer.review)) {
        return 'detrator';
      }

      return 'neutro';
    },

    checkName(anonymous, name) {
      if (this.$route.name === 'Respostas') {
        if (
          anonymous && this.userProfile.permissions.answers.anonymous_profile &&
          !this.userProfile.permissions.answers.anonymous_profile
        ) {
          return this.$t('treatments.anonymous');
        } else if (
          this.userProfile.permissions.answers.anonymous_profile &&
          this.$route.name === 'Respostas'
        ) {
          return 'Nome: ***************';
        } else if (name) {
          return name;
        }
        return this.$t('treatments.noName');
      } else if (this.$route.name === 'Lixeira') {
        if (
          anonymous &&
          !this.userProfile.permissions.trash.anonymous_profile
        ) {
          return this.$t('treatments.anonymous');
        } else if (this.userProfile.permissions.trash.anonymous_profile) {
          return 'Nome: ***************';
        } else if (name) {
          return name;
        }
        return this.$t('treatments.noName');
      }
      return this.$t('treatments.noName');
    },

    checkUserData(anonymous, profileAnswer, profileTrash, value) {
      if (this.$route.name === 'Respostas') {
        if (anonymous || profileAnswer) {
          return '***************';
        } else if (value) {
          return value;
        }
      } else if (this.$route.name === 'Lixeira') {
        if (anonymous || profileTrash) {
          return '***************';
        }
      } else if (value) {
        return value;
      }

      return '-';
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'HH:mm');
      return `${day} às ${hour}`;
    },

    gradeFormat(grade) {
      if (this.customer.metric === 'nps-0-10' || this.customer.metric === 'csat-0-10(media)') {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.customer.metric.indexOf('1-5') > -1) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.customer.metric.indexOf('stars') > -1) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.customer.metric === 'like-dislike') {
        if (grade === 1) {
          return 'promoters';
        } else if (grade === 0) {
          return 'detractors';
        }
        return 'invalid';
      }

      return 'invalid';
    },

    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.customer.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              item.selectedIndicator &&
              this.customer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.customer.indicators[i].value.toLowerCase() ===
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              item.selectedIndicator &&
              this.customer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.customer.indicators[i].value.toLowerCase() !==
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              this.customer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.customer.indicators[i].value && this.customer.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // remove accents
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },

    async mounted() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

      await this.getAllBranches();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.chip {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: $gray;
  border: 1px solid $white;
  color: $white;
  display: flex;
  align-items: center;
}

h4 {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 100;
}

.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  color: $white;
  font-weight: bold;
  font-size: 28px;
  margin-left: auto;
  margin-right: auto;
}

.flag-category-text {
  text-transform: lowercase;
}

.flag-category-close {
  cursor: pointer;
}

.flag-grade-promoters {
  background-color: #28a745;
}

.flag-grade-detractors {
  background-color: #dc3545;
}

.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}

.flag-grade-invalid {
  background-color: #c1c1c1;
}

.user-info {
  color: rgb(133, 131, 131);
  font-style: italic;
}

.header-div {
  display: flex;
  align-items: center;
  position: relative;
}

.header-div img {
  position: absolute;
  width: 50px;
  height: 50px;
  top: -5px;
  left: 0px;
}

.header-div p {
  margin: 0 0 0 55px;
}

.header-font {
  font-size: 20px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-addquestions/index.vue